import { Controller } from "@hotwired/stimulus"
import { getJSON } from "../api.js"

// Badge liczby nieprzeczytanych powiadomień systemowych w navbarze (przy „Ulubione").
// count > 0 → pokazuje liczbę; count = 0 lub błąd API → element ukryty (nawigacja nie może się wywalić).
export default class extends Controller {
  static values = {
    url: String, // /api/notifications/unread-count/
  }

  async connect() {
    let data
    try {
      data = await getJSON(this.urlValue)
    } catch {
      // Błąd sieci lub API — zachowujemy ukryty element bez hałasu w konsoli
      this.element.hidden = true
      this.element.textContent = ""
      return
    }
    const count = data?.count ?? 0
    if (count > 0) {
      this.element.textContent = String(count)
      this.element.hidden = false
    } else {
      this.element.hidden = true
      this.element.textContent = ""
    }
  }
}
